<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20" id="report-tracking">
      <h2>Báo cáo sản phẩm</h2>

      <div class="mt20">
        <p>
          Thiết bị có camera:
          <strong>{{hasCamera ? 'Có': 'Không'}}</strong>
        </p>

        <button
          v-if="hasCamera && !show_video"
          class="btn btn-primary"
          v-on:click="showCamera"
        >Bật camera</button>
        <button
          v-if="hasCamera && show_video"
          class="btn btn-danger"
          v-on:click="offCamera"
        >Tắt camera</button>

        <video v-if="show_video" muted width="100%" class="mt20" autoplay id="qr-video"></video>
      </div>
      <div class="mt10" v-if="qr_url">
        <p>
          <b>Tracking Link:</b>
          <a :href="qr_url">{{qr_url}}</a>
        </p>
        <loading v-if="working" class="mt10 text-center" :text="'Please wait'|translate"></loading>
        
        <div v-if="tracking_data && tracking_data.purchase_order ">
            <p><b>Nhà cung cấp :</b>  {{tracking_data.purchase_order.seller_name}} ({{tracking_data.purchase_order.seller_type|translate}})</p>
            <p><b>Nhà phân phối :</b> {{tracking_data.purchase_order.buyer_name}} ({{tracking_data.purchase_order.buyer_type|translate}}) </p>
            <p><b>Mã Code :</b> {{tracking_data.serial_item.unique_code}} </p>
            <form  v-on:submit.prevent="submitForm">
              <textarea class="form-control" rows="5" :disabled="sending" required v-model="report_detail.content" ></textarea>
              <button type="submit" class="btn btn-success mt10" :disabled="sending"> 
                <i v-if="sending" class="fas fa-spinner fa-spin"></i>
                {{'Submit'|translate}}</button>
            </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import QrScanner from "@/build_lib/qr-scanner.min.js"; // if using plain es6 import
import QrScannerWorkerPath from "!!file-loader!@/build_lib/qr-scanner-worker.min.js"; // if using plain es6 import
export default {
  name: "SearchCode",
  components: {
    MyHeader,
    Loading
  },
  data() {
    return {
      working: false,
      sending: false,
      hasCamera: false,
      show_video: false,
      tracking_data: null,
      qr_url: "",
      report_detail:{

      },
      qrScanner: null
    };
  },
  methods: {
    showCamera() {
      this.show_video = true;
      this.qr_url = "";
      setTimeout(() => {
        this.initCamera();
      }, 100);
    },

    setResult(label, result) {
      this.qr_url = result;
      this.offCamera();

      this.working = true;
      Utils.request(this, true)
        .get(`/searchCode/`, { params: { unique_code: this.qr_url } })
        .then(response => {
          this.working = false;
          if (response.data.status != "ok") {
            this.qr_url = "";
            Utils.showError(this,"Mã quét không tồn tại")
            return;
          }
          this.tracking_data = response.data.data;
          
          this.report_detail.serial_id = this.tracking_data.serial_item.id;
          
          
        })
        .catch(error => {});
    },
    initCamera() {
      const video = document.getElementById("qr-video");
      this.qrScanner = new QrScanner(video, result =>
        this.setResult(video, result)
      );
      this.qrScanner.start();
    },
    offCamera() {
      if (this.qrScanner) {
        this.show_video = false;
        this.qrScanner.destroy();
        this.qrScanner = null;
      }
    },
    submitForm(){


      this.sending =true;
      Utils.request(this, true, "retailer")
        .post(`/reportPurchase/`, this.report_detail)
        .then(response => {
          this.sending = false ;
          this.qr_url = "";
          Utils.showSuccess(this,"Cám ơn bạn đã phản hồi, chúng tôi đã gửi tới cho nhà phân phối");
          
        })
        .catch(error => {});
    }
  },

  mounted() {
    QrScanner.WORKER_PATH = QrScannerWorkerPath;

    QrScanner.hasCamera().then(hasCamera => {
      this.hasCamera = hasCamera;
    });

    // this.setResult(null, "http://localhost:8080/s/898RSSlCld");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Tracking/Report.vue